import { render, staticRenderFns } from "./SurgSidesErr.vue?vue&type=template&id=315a0fea&"
import script from "./SurgSidesErr.vue?vue&type=script&lang=js&"
export * from "./SurgSidesErr.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports